import { Stack, styled } from '@mui/material';

import { styledCustom } from '/styles';

export const Container = styledCustom(Stack)<{ $showBlock: boolean }>`
  position: relative;
  overflow: hidden;
  opacity: ${({ $showBlock }) => ($showBlock ? 1 : 0)};
  transform: ${({ $showBlock }) => ($showBlock ? 'translateY(0)' : 'translateY(-8px)')};
  visibility: ${({ $showBlock }) => ($showBlock ? 'visible' : 'hidden')};
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
  padding: 0 16px 16px 16px;

  #scroll-wrapper {
    --size-container: 100px;
    padding-bottom: 8px;
    max-height: var(--size-container);
    overflow: auto;
    min-height: 36px;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 20px;
      width: calc(100% - 25px);
      background: ${({ theme }) => `
        linear-gradient(
          180deg,
          rgba(${theme.palette.mode === 'dark' ? '0,0,0' : '255,255,255'},0) 0%,
          ${theme.palette.mode === 'dark' ? theme.palette.background.paper : '#fff'} 100%
        )
      `};
      backdrop-filter: blur(2px);

      pointer-events: none;
      z-index: 1;
      transition: opacity 0.3s ease 0.3s;
    }
  }
  ${({ $showBlock }) =>
    $showBlock &&
    `
      @container (min-height:var(--size-container)) {
    #scroll-wrapper::after {
      opacity: 1;
    }
  }
    `}

  &:hover {
    #scroll-wrapper::-webkit-scrollbar {
      width: 5px;
    }
    #scroll-wrapper::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: ${({ theme }) => theme.palette.action.active};
    }
    #scroll-wrapper::-webkit-scrollbar-track {
      background: transparent;
    }
  }
`;

export const IconWrapper = styled('div')`
  cursor: help;
`;
